module.exports = __webpack_public_path__ + "static/media/phabricator.05d30e8f.svg";